// extracted by mini-css-extract-plugin
module.exports = {"container":"i_ZL","title":"i_ZM","labels":"i_ZN","label":"i_ZO","doughnuts":"i_ZP"};